/* eslint-disable react-hooks/exhaustive-deps, jsx-a11y/anchor-is-valid */
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  TextField,
  Snackbar,
  Alert,
  AlertTitle,
  Typography,
} from "@mui/material";
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import React, { useState , useEffect } from "react";
import { useTheme } from "../../style/theme";
import LockIcon from "@mui/icons-material/Lock";
import { Grid } from "@mui/material";
import visaImage from "../../assets/PaymentsImages/vizaa2.png"; // Update with actual path to Visa image
import mastercardImage from "../../assets/PaymentsImages/Mastercard.png"; // Update with actual path to Mastercard image
import amexImage from "../../assets/PaymentsImages/american_22.png"; // Update with actual path to American Express image
// import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // Check Icon
// import CheckIcon from "@mui/icons-material/Check"; // Check Icon
import Image from "../Image";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { GrCreditCard } from "react-icons/gr";
import Loader from "../../assets/loader.gif";
import starterImg from "../../assets/startericon.png";
import privateImg from "../../assets/privateicon.png";
import businessImg from "../../assets/businessicon.png";
import enterpriseImg from "../../assets/enterpriseicon.png";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
// import axios from "axios";
import { useUser } from "../../hooks/Authorize";
import axios from "axios";

const steps = ["Plan", "Add-Ons", "Pay", "Confirmation"];
const activeSteps = [0, 1, 2]; // Dynamically set the active step (currently step 1).

const PayStep = () => {
  const stripe = useStripe();
  const elements = useElements();
  const platformUser = useUser();
  const organizationId = localStorage.getItem("orgId");
  // const usename = platformUser?.firstName;
  // const userid = platformUser?._id;
  // const useremail = platformUser.email;

  const [showMessage, setShowMessage] = useState({
    show: true,
    message: "",
    severity: "",
  });

  // const [zip, setZip] = useState(0);

  // const [checked, setChecked] = useState(false); // Track checkbox state
  // const [addBillingAddress, setAddBillingAddress] = useState(false); // Track checkbox state
  // const handleClick = () => {
  //   setChecked(!checked); // Toggle the checked state on click
  // };
  // const [formData, setFormData] = useState({
  //   country: "",
  //   city: "",
  //   address1: "",
  //   building: "",
  //   address2: "",
  //   state: "",
  //   taxId: "",
  //   sameAddress: true,
  // });

  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const subscriptionSummary = location.state?.subscriptionSummary;
  const id = location.state?.id;
  // const getformData = location.state?.formData;
  const {
    plan,
    billingCycle,
    billingCycleAmount,
    adonsData,
    nextBillingDate,
    totalAmount,
    currDate,
    email,
    noOfUsers,
    FilesPlans
  } = subscriptionSummary || {};

  // console.log("Received formData:", adonsData, "-", subscriptionSummary);
  // useEffect(() => {
  // }, [getformData]);\]

  const isFiles = adonsData?.extraStorage ? true : false;


 const FilesDetail = {
  ...(adonsData?.extraStorage?.label === "Free 1 GB of storage" && {
    plan: FilesPlans?.[0],
  }),
  ...(adonsData?.extraStorage?.label === "Pro 250 GB of storage" && {
    plan: FilesPlans?.[1],
  }),
  ...(adonsData?.extraStorage?.label === "Team 1 TB of storage" && {
    plan: FilesPlans?.[2],
  }),
  ...(adonsData?.extraStorage?.label === "Enterprise 5 TB of storage" && {
    plan: FilesPlans?.[3],
  }),
};


  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: type === "checkbox" ? checked : value,
  //   });
  // };
  const { mode } = useTheme();
  const [subscriptionUser, setSubscriptionUser] = useState(null);

  // const cardStyle = {
  //   style: {
  //     base: {
  //       color: mode === 'light' ? '#000' : '#fff',
  //       fontSmoothing: "antialiased",
  //       fontSize: "16px",
  //       border: "1px solid red",
  //       "::placeholder": {
  //         color: "#3e3e3e",
  //       },
  //     },
  //     invalid: {
  //       color: "#FF3333        ",
  //       iconColor: "#FF3333        ",
  //     },
  //   },
  // };

 const getSubscription = async () => {
    // setLoadingPlans(true); // 👈 start loading
    try {
      const response = await axios.post(
        `/subscription/check-hr`, { orgId: id, userId: platformUser?._id }
      );
      const subscription = response.data.subscription;
      setSubscriptionUser(subscription);
    } catch (error) {
      console.error("Failed to fetch plans:", error);
    } finally {
      // setLoadingPlans(false); // 👈 stop loading
    }
  };

  
useEffect(()=>{
  getSubscription()
},[])


  const cardStyle = {
    style: {
      base: {
        color: mode === "light" ? "#000" : "#ffffff",
        fontSize: "16px",
        fontFamily: "Arial, sans-serif",
        iconColor: "#cccccc",
        "::placeholder": {
          color: "#a5a5a5",
        },
        backgroundColor: "transparent",

        padding: "12px 16px",
        height: "56px",
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
    placeholder: "4200 4525 4242 4254",
  };

  const ExpireStyle = {
    style: {
      base: {
        color: mode === "light" ? "#000" : "#ffffff",
        fontSize: "16px",
        iconColor: "#cccccc",
        "::placeholder": {
          color: "#a5a5a5",
        },
        backgroundColor: "transparent",
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };
  const CVCStyle = {
    style: {
      base: {
        color: mode === "light" ? "#000" : "#ffffff",
        fontSize: "16px",
        iconColor: "#cccccc",
        "::placeholder": {
          color: "#a5a5a5",
        },
        // backgroundColor: "#1e1e1e",
        // padding: "12px 16px", // yahan padding input ke andar ka hota hai
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
    placeholder: "CVV",
  };

  const navigate = useNavigate();

  // const isButtonDisabled =
  //   name === "" ||
  //   zip.length !== 6 ||
  //   !cardNumberComplete ||
  //   !cardExpiryComplete ||
  //   !cardCvcComplete;

  // const getBillingDate = () => {
  //   const date = new Date();
  //   date.setDate(date.getDate() + 7);
  //   return date.toLocaleDateString("en-US", {
  //     month: "long",
  //     day: "numeric",
  //     year: "numeric",
  //   });
  // };

  // const handleChangeConfirm = () => {
  //   navigate("/confirm-subscription");
  // };
  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page in the history stack
  };

  const handleClose = () => {
    setShowMessage({ show: false, message: " ", severity: "" });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardNumberElement);
    console.log(name, "NAMEEEEEEEEEE");

    if (!name) {
      setShowMessage({
        show: true,
        message: "Please complete all card details and enter your name.",
        severity: "warning",
      });
      setLoading(false);
      return;
    }

    const { error: paymentError, paymentMethod } =
      await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        // billing_details: {
        //   name ,
        //   email: platformUser?.email || "",
        //   address: {
        //     // postal_code: formData.zip || "",
        //     line1: formData.address1 || "",
        //     line2: formData.address2 || "",
        //     city: formData.city || "",
        //     state: formData.state || "",
        //     country: formData.country || "",
        //   },
        // },
      });
    console.log(paymentError, "paymentErrorpaymentError");
    if (paymentError) {
      setShowMessage({
        show: true,
        message: "Please complete all card details and enter your name.",
        severity: "warning",
      });
      setLoading(false);
      return;
    }

    const { token, error: tokenError } = await stripe.createToken(cardElement, {
      name,
      address_zip: "",
    });

    if (tokenError) {
      setShowMessage({
        show: true,
        message: "Error creating token",
        severity: "error",
      });
      setLoading(false);
      return;
    }

    const payload = {
      userId: platformUser?._id || "",
      name: platformUser?.firstName || "",
      email: platformUser?.email || "",
      paymentMethod: paymentMethod.id,
      tokenId: token.id,
      card: token.card,
      plan: plan.name,
      planId: plan._id,
      amount: plan.amount,
      orgId: organizationId,
      addons: adonsData,
      billingCycle: billingCycle,
    };
    
    const payloadFiles = {
      userId: platformUser?._id || "",
      name: platformUser?.firstName || "",
      email: platformUser?.email || "",
      paymentMethod: paymentMethod.id,
      tokenId: token.id,
      card: token.card,
      plan: FilesDetail?.plan?.name,
      planId: FilesDetail?.plan?._id,
      amount: FilesDetail?.plan?.amount,
      orgId: organizationId,
    };


    try {
      setLoading(false);
      navigate("/confirm-subscription", {
        state: {
          payload,
          subscriptionSummary,
          name,
          FreePlan:FilesDetail?.plan?.name,
          payloadFiles,
          isFiles
        },
      });
    } catch (e) {
      console.error(e);
      setLoading(false);
      setShowMessage({
        show: true,
        message: "Error creating subscription",
        severity: "error",
      });
    }
  };

  return (
    <Box
      sx={{
        overflow: "hidden",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Snackbar
        open={showMessage.show}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert
          severity={showMessage.severity}
          variant="filled"
          sx={{ width: "100%" }}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <AlertTitle> {showMessage.severity}</AlertTitle>
          {showMessage.message}
        </Alert>
      </Snackbar>
      <Box>
        <Button
          onClick={handleBackClick}
          sx={{
            color: mode === "light" ? "#26272C" : "#FFFFFF",
            // padding: "0.5rem 1rem",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            borderRadius: "5px",
          }}
        >
          <ArrowBackIcon sx={{ marginRight: "0.5rem" }} />
        </Button>
      </Box>

      <Box>
        {/* Header */}
        <Typography variant="h6" sx={{ color: "#A5A5A5", textAlign: "center" }}>
          Subscribe to Clikkle{" "}
          <span style={{ color: "#3B84D9", fontWeight: "bold" }}>HR</span> in 4
          Easy Steps
        </Typography>
      </Box>

      {/* Steps */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          py: 2,
          px: { xs: "2rem", sm: "5rem" },
          mb: "2rem",
        }}
      >
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                zIndex: 1,
                mb: "-1.5rem",
                gap: "0.6rem",
                minWidth: { xs: "70px", sm: "auto" }, // prevent shrink on small
              }}
            >
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: activeSteps.includes(index)
                    ? "#407BFF"
                    : "transparent",
                  border: "1px solid gray",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: activeSteps.includes(index) ? "black" : "#A5A5A5",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                {index + 1}
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  color: activeSteps.includes(index) ? "#fff" : "#A5A5A5",
                  fontSize: { xs: "0.75rem", sm: "0.9rem" },
                  width: { xs: "60px", sm: "auto" },
                }}
              >
                {step}
              </Typography>
            </Box>
            {index < steps.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  height: "1px",
                  backgroundColor:
                    activeSteps.includes(index) &&
                    activeSteps.includes(index + 1)
                      ? "#407BFF"
                      : "#A5A5A5",
                  mx: { xs: "auto", sm: "10px" }, // margin X
                  my: { xs: "0.7rem", sm: 0 }, // margin Y
                  width: { xs: "60%", sm: "100%" },
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Box>

      <Grid
        container
        spacing={2}
        sx={{ px: 2, height: "100%", overflow: "hidden" }}
      >
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            height: "100%",
            overflowY: "auto",
            pr: 2,
            py: 1,
            scrollbarWidth: "none",
          }}
        >
          <Box mt={3} sx={{ marginTop: "2rem", textAlign: "left" }}>
            <Typography
              sx={{
                fontSize: "26px",
                fontWeight: "600",
                color: mode === "light" ? "#000" : "#fff",
              }}
            >
              Subscription Details
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#A5A5A5",
                marginTop: "8px",
                lineHeight: "1.5",
                whiteSpace: "nowrap", // Ensures this text stays on one line
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "left", // Aligns text to left
              }}
            >
              By adding your payment details, you'll ensure uninterrupted access
              to your team's site once your trial ends.
            </Typography>
            <Typography
              sx={{
                fontSize: "26px",
                fontWeight: "600",
                color: mode === "light" ? "#000" : "#fff",
                marginTop: "30px",
              }}
            >
              Add Payment Method
            </Typography>

            {/* Second Text: Two lines */}
            <Typography
              sx={{
                fontSize: "13px",
                color: "#A5A5A5",
                marginTop: "10px",
                lineHeight: "1.5",
                display: "flex",
                alignItems: "center",
              }}
            >
              <LockIcon sx={{ marginRight: "8px", fontSize: "16px" }} />{" "}
              {/* Lock Icon */}
              Your payment details are securely encrypted for protection.
              Clikkle will use this as your default payment method for future
              transactions on this account. You can update or remove it at any
              time.
            </Typography>
          </Box>

          <Box
            item
            xs={12}
            sx={{ display: "flex", alignItems: "center", gap: 2, py: 2 }}
          >
            {/* Visa */}
            <Grid item>
              <img
                src={visaImage}
                alt="Visa"
                width="80"
                height="50"
                style={{ borderRadius: "5px", objectFit: "cover" }}
              />
            </Grid>

            {/* MasterCard */}
            <Grid item>
              <img
                src={mastercardImage}
                alt="MasterCard"
                width="80"
                height="50"
                style={{ borderRadius: "5px", objectFit: "cover" }}
              />
            </Grid>

            {/* American Express */}
            <Grid item>
              <img
                src={amexImage}
                alt="American Express"
                width="80"
                height="50"
                style={{ borderRadius: "5px", objectFit: "cover" }}
              />
            </Grid>
          </Box>

          {/* form */}
          <Grid container spacing={2}>
            {/* Credit Card Number Label */}
            <Grid item xs={12} md={7}>
              <Typography
                variant="h6"
                style={{
                  color: "#A5A5A5",
                  fontSize: "15px",
                  marginBottom: "10px",
                }}
              >
                Credit Card Number
              </Typography>

              {/* <div className="relative"> */}

              {/* Card Input */}
              {/* <div className=""> */}
              <div
                style={{
                  border: "2px solid #3C3C3C",
                  borderRadius: "5px",
                  padding: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div
                  className="flex-1"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <GrCreditCard size={20} />
                </div>

                <div
                  className="flex-1"
                  style={{ display: "flex", flexGrow: 1 }}
                >
                  <div style={{ width: "100%" }}>
                    <CardNumberElement options={cardStyle} />
                  </div>
                </div>
              </div>
              {/* </div> */}
              {/* </div> */}
            </Grid>

            {/* Expiration Date */}
            <Grid item xs={12} md={2.5}>
              <Typography
                variant="h6"
                style={{
                  color: "#A5A5A5",
                  fontSize: "15px",
                  marginBottom: "10px",
                }}
              >
                Expiration Date
              </Typography>
              <div
                style={{
                  border: "2px solid #3C3C3C",
                  borderRadius: "5px",
                  padding: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div style={{ width: "100%" }}>
                  <CardExpiryElement options={ExpireStyle} />
                </div>
              </div>
            </Grid>
            {/* CVC */}
            <Grid item xs={12} md={2.5}>
              <Typography
                variant="h6"
                style={{
                  color: "#A5A5A5",
                  fontSize: "15px",
                  marginBottom: "10px",
                }}
              >
                CVC
              </Typography>
              <div
                style={{
                  border: "2px solid #3C3C3C",
                  borderRadius: "5px",
                  padding: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div style={{ width: "100%" }}>
                  <CardCvcElement options={CVCStyle} />
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                style={{
                  color: "#A5A5A5",
                  fontSize: "15px",
                  marginBottom: "10px",
                }}
              >
                Name on Card
              </Typography>
              <TextField fullWidth onChange={(e) => setName(e.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={handleSubmit}
                // onClick={() => setAddBillingAddress(false)} // Close the form
                variant="contained"
                sx={{
                  backgroundColor: "#444",
                  color: "#fff",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#666",
                  },
                  width: "100%",
                  py: 2,
                  mb: 2,
                }}
              >
                {loading ? (
                  <>
                    <img alt="loading..." src={Loader} width={15} />
                  </>
                ) : (
                  "Next"
                )}
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={4} sx={{ height: "100%", overflow: "hidden" }}>
          {/* Subscriptions Summarry card */}
          <Box
            sx={{
              position: "relative",
              borderRadius: "10px",
              overflow: "hidden",
              p: "2px", // for visible gradient border thickness
              background: "linear-gradient(45deg, #6A0B61, #3767B1)",
            }}
          >
            <Card
              sx={{
                borderRadius: "inherit",
                backgroundColor: mode === "light" ? "white" : "black",
                width: "100%",
                height: "100%",
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    color: mode === "light" ? "black" : "#FFFFFF",
                    pb: 1, // Adds padding below text
                    borderBottom: "1px solid #5C5C5C", // Adds border below text
                  }}
                >
                  Subscription Summary
                </Typography>

                {/* <Box
                  sx={{
                    backgroundColor: "#3767B11A",
                    color: "#407BFF",
                    fontSize: "12px",
                    fontWeight: "bold",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    display: "inline-block",
                    marginTop: "14px",
                  }}
                >
                  14 DAYS LEFT IN TRIAL
                </Box> */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box display="flex" alignItems="center" mt="1rem">
                    <Box
                      sx={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: `1px solid ${
                          mode === "light" ? "#d1d5db" : "#2E2E2E"
                        }`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "8px", // Adds some space between image and text
                        // mt:"2rem"
                      }}
                    >
                      <Image
                        src={
                          plan?.name === "Starter"
                            ? starterImg
                            : plan?.name === "Private"
                            ? privateImg
                            : plan?.name === "Business"
                            ? businessImg
                            : enterpriseImg
                        }
                        alt="logo"
                        width={20}
                        height={20}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "25px",
                        fontWeight: "500",
                        color: mode === "light" ? "black" : "#fff",
                      }}
                    >
                      {plan.name || "N/A"}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "25px",
                      fontWeight: "500",
                      color: mode === "light" ? "black" : "#fff",
                      mt: "1rem",
                    }}
                  >
                    $
                    {billingCycle === "Yearly"
                      ? billingCycleAmount / 12
                      : billingCycleAmount || "N/A"}
                    <span style={{ fontSize: "12px" }}> /monthly</span>
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt="1rem"
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    Organization URL
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    {email}
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt="1rem"
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    Per user
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    {noOfUsers}
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt="1rem"
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    Billing Cycle
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    {billingCycle}
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt="1rem"
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    Billing Starts On
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    {currDate}
                  </Typography>
                </Box>

                <Divider sx={{ backgroundColor: "#5C5C5C", marginY: "15px" }} />

                <Box sx={{ mb: "2rem" }}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      sx={{
                        fontSize: "25px",
                        color: mode === "light" ? "black" : "#FFFFFF",
                      }}
                    >
                      {billingCycle === "Yearly" ? "Yearly" : "Monthly"} Total
                    </Typography>
                    <Box sx={{ mt: "1rem" }}>
                      <Typography
                        sx={{
                          fontSize: "25px",
                          color: mode === "light" ? "black" : "#FFFFFF",
                        }}
                      >
                        ${totalAmount}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "12px",
                          textAlign: "right",
                          color: "#A5A5A5",
                        }}
                      >
                        (excluding tax)
                      </Typography>
                    </Box>
                   
                  </Box>
                  {/* <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      sx={{
                        fontSize: "25px",
                        color: mode === "light" ? "black" : "#FFFFFF",
                      }}
                    >
                      
                      Privious Pay
                    </Typography>
                    <Box sx={{ mt: "1rem" }}>
                      <Typography
                        sx={{
                          fontSize: "25px",
                          color: mode === "light" ? "black" : "#FFFFFF",
                        }}
                      >
                        ${subscriptionUser?.amount}
                      </Typography>
                    </Box>
                   
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      sx={{
                        fontSize: "25px",
                        color: mode === "light" ? "black" : "#FFFFFF",
                      }}
                    >
                      
                      Total Pay
                    </Typography>
                    <Box sx={{ mt: "1rem" }}>
                      <Typography
                        sx={{
                          fontSize: "25px",
                          color: mode === "light" ? "black" : "#FFFFFF",
                        }}
                      >
                        ${totalAmount - subscriptionUser?.amount}
                      </Typography>
                    </Box>
                   
                  </Box> */}
                </Box>

                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "#A5A5A5",
                    textAlign: "center",
                    mt: "1rem",
                  }}
                >
                  You won’t be charged until {nextBillingDate}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PayStep;

// {!addBillingAddress ? (
//   <Grid item xs={12}>
//     <Typography
//       variant="h6"
//       style={{
//         color: mode === "light" ? "#000" : "#fff",
//         fontSize: "25px",
//       }}
//     >
//       Billing Address
//     </Typography>
//     <Typography
//       variant="h6"
//       sx={{ color: "#A5A5A5", fontSize: "12px", marginTop: "15px" }}
//     >
//       {name}
//     </Typography>

//     <Typography
//       variant="h6"
//       sx={{ color: "#A5A5A5", fontSize: "12px", marginTop: "15px" }}
//     >
//       {formData?.address1} {formData?.city} {formData?.country}
//     </Typography>
//     <Typography
//       variant="h6"
//       sx={{ color: "#A5A5A5", fontSize: "12px", marginTop: "15px" }}
//     >
//       {formData?.address2} {formData?.building} {formData?.state}
//     </Typography>
//     <Typography
//       variant="h6"
//       sx={{ color: "#A5A5A5", fontSize: "12px", marginTop: "15px" }}
//     >
//       {formData?.taxId}
//     </Typography>

//     <Typography
//       variant="h6"
//       sx={{ color: "#A5A5A5", fontSize: "12px", marginTop: "15px" }}
//     >
//       Sold-to address is the same as billing address
//     </Typography>

//     <Typography
//       onClick={() => setAddBillingAddress(true)}
//       variant="h6"
//       sx={{
//         color: "#3767B1",
//         cursor: "pointer",
//         fontSize: "12px",
//         marginTop: "15px",
//       }}
//     >
//       Edit address
//     </Typography>

//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         gap: "10px",
//         mt: 2,
//       }}
//     >
//       <Box
//         onClick={handleClick}
//         sx={{
//           width: "20px",
//           height: "20px",
//           border: "1px solid #A5A5A5", // Square border
//           borderRadius: "0", // Square shape
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         {checked && (
//           <CheckIcon sx={{ fontSize: "16px", color: "#407BFF" }} /> // Show check icon when checked
//         )}
//       </Box>
//       <Box>
//         {/* Agreement Text with Custom Color */}
//         <Typography
//           sx={{
//             fontSize: "14px",
//             color: "#A5A5A5", // Default color
//             lineHeight: "1.5",
//           }}
//         >
//           I agree to the{" "}
//           <span style={{ color: "#3767B1" }}>
//             Clikkle Customer Agreement
//           </span>{" "}
//           and acknowledge the{" "}
//           <span style={{ color: "#3767B1" }}>
//             Clikkle Privacy Policy
//           </span>
//           .
//         </Typography>
//       </Box>
//     </Box>

//     <Box>
//       <Button
//         sx={{
//           backgroundColor: checked ? "#2D2924" : "#45413C",
//           width: "100%",

//           color: mode === "light" ? "#fff" : "#A5A5A5",
//           // color: "#A5A5A5", // Text color white
//           fontSize: "16px",
//           padding: "12px 40px", // Increased padding for larger button
//           borderRadius: "5px",
//           marginTop: "20px", // Added space between text and button
//           cursor: checked ? "pointer" : "not-allowed", // Disable button if not checked
//           "&:hover": {
//             backgroundColor: checked ? "#2D2924" : "#C7C7C7", // Slightly darker on hover when checked
//           },
//         }}
//         disabled={!checked || loading} // Disable button when checkbox is unchecked
//         // onClick={handleChangeConfirm}
//         onClick={handleSubmit}
//       >
//         {loading ? (
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "8px",
//             }}
//           >
//             <span>PLEASE WAIT</span>
//             <img
//               src={Loader}
//               width={18}
//               height={18}
//               alt="Loading..."
//             />
//           </div>
//         ) : (
//           "  Confirm Subscription"
//         )}
//       </Button>
//     </Box>

//     <Box>
//       <Typography
//         sx={{
//           fontSize: "12px", // Smaller text size for additional terms
//           color: "#A5A5A5",
//           marginTop: "20px", // Added space between button and text
//           lineHeight: "1.5",
//           wordWrap: "break-word", // Ensure text breaks into multiple lines
//           whiteSpace: "normal", // Allow text to wrap
//           maxWidth: "1000px", // Limit width to encourage text to wrap
//           display: "inline-block", // Ensures text wraps as needed within the max-width
//         }}
//       >
//         By selecting “Confirm Subscription” you agree to pay the total
//         amount of each billing cycle starting when your trial ends
//         until your subscription is canceled. The amount will reflect
//         user count and any applicable discounts, promotions or
//         credits. You can{" "}
//         <span style={{ color: "#3767B1" }}>cancel</span> anytime. If
//         prices change, we’ll notify you.
//       </Typography>
//     </Box>
//   </Grid>
// ) : (
//   <Grid container spacing={2}>
//     <Grid item xs={12}>
//       <Typography
//         variant="h6"
//         style={{ color: mode === "light" ? "#B0A9A5" : "#FFFFFF", fontSize: "25px" }}
//       >
//         Billing Address
//       </Typography>
//     </Grid>
//     <Grid item xs={12}>
//       <Typography variant="body2" mb={1}
//       sx={{color: mode === "light" ? "#B0A9A5" : "#FFFFFF"}}>
//         Country*
//       </Typography>
//       <FormControl fullWidth variant="outlined">
//         <Select
//           name="country"
//           value={formData.country}
//           onChange={handleChange}
//           displayEmpty
//           sx={{
//             color: mode === "light" ? "#B0A9A5" : "#FFFFFF",
//             ".MuiOutlinedInput-notchedOutline": {
//               borderColor: "#ccc",
//             },
//             "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#407BFF",
//             },
//             "&:hover .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#aaa",
//             },
//           }}
//         >
//           <MenuItem value="" disabled>
//             Select
//           </MenuItem>
//           <MenuItem value="USA">USA</MenuItem>
//           <MenuItem value="Canada">Canada</MenuItem>
//           <MenuItem value="UK">UK</MenuItem>
//         </Select>
//       </FormControl>
//     </Grid>

//     <Grid item xs={12}>
//       <Typography variant="body2" mb={1}
//       sx={{color: mode === "light" ? "#B0A9A5" : "#FFFFFF"}}>
//         City*
//       </Typography>
//       <TextField
//         fullWidth
//         name="city"
//         value={formData.city}
//         onChange={handleChange}
//         variant="outlined"
//         InputProps={{
//           style: {color: mode === "light" ? "#B0A9A5" : "#FFFFFF"},
//         }}
//       />
//     </Grid>

//     <Grid item xs={12}>
//       <Typography variant="body2" mb={1}
//       sx={{color: mode === "light" ? "#B0A9A5" : "#FFFFFF"}}>
//         Address*
//       </Typography>
//       <TextField
//         fullWidth
//         name="address1"
//         value={formData.address1}
//         onChange={handleChange}
//         variant="outlined"
//         InputProps={{
//           style: {color: mode === "light" ? "#B0A9A5" : "#FFFFFF"},
//         }}
//       />
//     </Grid>

//     <Grid item xs={12}>
//       <TextField
//       sx={{color: mode === "light" ? "#B0A9A5" : "#FFFFFF"}}
//         fullWidth
//         variant="standard"
//         label="+ Add building number, suite, floor, etc."
//         name="building"
//         value={formData.building}
//         onChange={handleChange}
//         InputLabelProps={{ style: {color: mode === "light" ? "#B0A9A5" : "#FFFFFF"}}}
//         InputProps={{
//           style: {color: mode === "light" ? "#B0A9A5" : "#FFFFFF"},
//           disableUnderline: true,
//         }}
//       />
//     </Grid>

//     <Grid item xs={6}>
//       <Typography variant="body2" mb={1}
//       sx={{color: mode === "light" ? "#B0A9A5" : "#FFFFFF"}}>
//         Address*(optional)
//       </Typography>
//       <TextField
//       sx={{color: mode === "light" ? "black" : "#FFFFFF"}}
//         fullWidth
//         name="address2"
//         value={formData.address2}
//         onChange={handleChange}
//         variant="outlined"
//         InputProps={{
//           style: {color: mode === "light" ? "#B0A9A5" : "#FFFFFF"},
//         }}
//       />
//     </Grid>

//     <Grid item xs={6}>
//       <Typography variant="body2" mb={1}
//       sx={{color: mode === "light" ? "#B0A9A5" : "#FFFFFF"}}>
//         State*
//       </Typography>
//       <FormControl fullWidth variant="outlined">
//         <Select
//           name="state"
//           value={formData.state}
//           onChange={handleChange}
//           displayEmpty
//           sx={{
//             color: mode === "light" ? "#B0A9A5" : "#FFFFFF",
//             ".MuiOutlinedInput-notchedOutline": {
//               borderColor: "#ccc",
//             },
//             "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#407BFF",
//             },
//             "&:hover .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#aaa",
//             },
//           }}
//         >
//           <MenuItem value="" disabled>
//             Select
//           </MenuItem>
//           <MenuItem value="NY">New York</MenuItem>
//           <MenuItem value="CA">California</MenuItem>
//           <MenuItem value="TX">Texas</MenuItem>
//         </Select>
//       </FormControl>
//     </Grid>

//     <Grid item xs={12}>
//       <TextField
//       sx={{color: mode === "light" ? "black" : "#FFFFFF"}}
//         fullWidth
//         label="+ Add Tax ID (Optional)"
//         name="taxId"
//         value={formData.taxId}
//         onChange={handleChange}
//         variant="standard"
//         InputLabelProps={{ style: {color: mode === "light" ? "#B0A9A5" : "#FFFFFF"} }}
//         InputProps={{
//           disableUnderline: true,
//           style: {color: mode === "light" ? "#B0A9A5" : "#FFFFFF"},
//         }}
//       />
//     </Grid>

//     <Grid item xs={12}>
//       <FormControlLabel
//         control={
//           <Checkbox
//             checked={formData.sameAddress}
//             onChange={handleChange}
//             name="sameAddress"
//             sx={{color: mode === "light" ? "#B0A9A5" : "#FFFFFF"}}
//           />
//         }
//         label={
//           <Box display="flex" alignItems="center">
//             Sold-to address (used for tax) is same as billing address
//             <Tooltip title="This is the address used for tax purposes.">
//               <IconButton size="small" sx={{ color: "#aaa", ml: 1 }}>
//                 <HelpOutlineIcon fontSize="small" />
//               </IconButton>
//             </Tooltip>
//           </Box>
//         }
//       />
//     </Grid>

//
//   </Grid>
// )}
